<template>
  <!-- <section class="boxWithBorder"> -->

  <div>
    <b-field label="Where should notifications be sent when a traveler books an option that violates a rule?" />
    <b-field>
      <b-checkbox type="is-primary" v-model="nObj.managerViaEmail" @input="emitNotificationObject">
        Email to the traveler's manager
      </b-checkbox>
    </b-field>
    <b-field>
      <b-checkbox type="is-primary" v-model="nObj.managerViaSms" @input="emitNotificationObject">
        SMS / text message to the traveler's manager
      </b-checkbox>
    </b-field>

    <EmailAndPhoneList :email="nObj.email" :sms="nObj.sms" @remove="remove" @input="emitNotificationObject" />
    <div class="mb-4">
      <b-button class="button is-primary " @click="addEmail = true" @input="emitNotificationObject">ADD CUSTOM
        EMAIL</b-button>&nbsp;&nbsp;
      <b-button class="button is-primary " @click="addPhone = true" @input="emitNotificationObject"> ADD CUSTOM MOBILE
        NUMBER</b-button>
    </div>

    <Email v-if="addEmail" @cancel="cancel" @saveEmail="saveEmail" @input="emitNotificationObject" />
    <Mobile v-if="addPhone" @cancel="cancel" @savePhone="savePhone" @input="emitNotificationObject" />
    <!-- </section> -->
  </div>
</template>
<script>

import Email from "./Email";
import Mobile from "./Mobile";
import EmailAndPhoneList from "./EmailAndPhoneList.vue";
export default {
  name: "Notification",
  props: {
    notifications: {
      type: [Object],
    }

  },
  components: {
    Mobile,
    Email,
    EmailAndPhoneList
  },
  data() {
    return {
      nObj: {
        managerViaEmail: true,
        managerViaSms: false,
        email: [],
        sms: [],
      },
      addEmail: false,
      addPhone: false,
      countryCode: '+1',
    }
  },
  methods: {
    cancel(val) {
      if (val == 'email') {
        this.addEmail = false
      } else {
        this.addPhone = false;
      }
    },
    saveEmail(data) {
      this.addEmail = false;
      let _arr = this.nObj.email
      _arr = [..._arr, data]
      this.nObj.email = _arr
      //this.nObj.email.push(data);

      this.$emit('emitData', this.nObj);
    },
    savePhone(data) {
      if (data) {
        this.addPhone = false;
        data = data.replace(/[^\w\s]/gi, "");
        data = this.countryCode + data;

        let _arr = this.nObj.sms
        _arr = [..._arr, data]
        this.nObj.sms = _arr
      }
      this.$emit('emitData', this.nObj);
    },
    remove(obj) {
      if (obj.val == 'email') {
        let _arr = this.nObj.email
        let result =  [..._arr.slice(0, obj.index), ..._arr.slice(obj.index + 1)];
        this.nObj.email = result;
      } else {
        let _arr = this.nObj.sms
        let result =  [..._arr.slice(0, obj.index), ..._arr.slice(obj.index + 1)];
        this.nObj.sms = result;
      }
      this.$emit('emitData', this.nObj);
    },
    emitNotificationObject() {
      this.$emit('emitData', this.nObj);
    }
  },
  mounted() {
    this.$emit('emitData', this.nObj);

  },
  watch: {
    notifications: {
      handler(newVal, prevVal) {
        this.nObj = {
          email: newVal.email,
          managerViaEmail: newVal.managerViaEmail,
          managerViaSms: newVal.managerViaSms,
          sms: newVal.sms
        }
      },
      deep: true
    },
  }
}
</script>